import { isEmpty } from "../../Util"
import { useSelector } from "react-redux"

const Result = ({renderer = true, status, successMessage = '', failureMessage = '', mailTo,title=false}) => {
    const error = useSelector((state) => state.Reducer.error)

    return (
        renderer && isEmpty(error) && !isEmpty(status) && 
        <div className="az-pay-success"> 
            { (status === 'Succeeded' || status === 'Accepted') ?
                <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none"><rect width="64" height="64" fill="#E8F3E9" rx="32"/><path fill="#1E8927" fillRule="evenodd" d="M46.923 20.1971c-.2648-.2628-.662-.2628-.9268 0L26.6643 40.8235l-8.739-8.671c-.2648-.2628-.6621-.2628-.9269 0-.2648.2627-.2648.6569 0 .9196l9.2687 9.1965s.2648.1314.3972.1314c.1324 0 .3973-.1314.5297-.2628l19.8615-21.0205c.2648-.2627.1324-.6569-.1325-.9196Z" clipRule="evenodd"/></svg>
                    {title && <div className="result-title">{title}</div>}
                    <div className="success-message mt-2">{successMessage}</div>
                </> 
            : 
                <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none"><rect width="64" height="64" fill="#FCE5EB" rx="32"/><path fill="#DC3149" fillRule="evenodd" d="m32.9282 31.9833 10.7403-10.815c.2652-.267.2652-.6676 0-.9346-.2652-.2671-.663-.2671-.9282 0L32 31.0487 21.2597 20.1001c-.2652-.1335-.7956-.1335-1.0608 0-.2652.1336-.1326.8012 0 1.0682l10.7403 10.815-10.7403 10.815c-.2652.2671-.2652.6676 0 .9347.1326.267.3978.267.5304.267s.3978 0 .5304-.1335L32 33.0515l10.7403 10.815c.1326.1335.2652.1335.5304.1335s.3978 0 .5304-.1335c.2652-.2671.2652-.6676 0-.9346L32.9282 31.9833Z" clipRule="evenodd"/></svg>
                    <div className="text-center error-message">
                        {failureMessage + ' '}  
                        {mailTo && <a href={"mailto:" + process.env.REACT_APP_CONTACT_EMAIL}>{process.env.REACT_APP_CONTACT_EMAIL}</a>} 
                    </div>
                </>
            }    
        </div>    
    );
}
export default Result;